// 多语言配置文件
// 注意：所有翻译键都使用简体中文作为key，这样便于开发和维护

import { createI18n } from 'vue-i18n'

// 导入语言文件
import zhCn from './locales/zh-cn.js'
import zhTw from './locales/zh-tw.js'
import en from './locales/en.js'
import fr from './locales/fr.js'
import pt from './locales/pt.js'
import es from './locales/es.js'
import pl from './locales/pl.js'
import de from './locales/de.js'
import it from './locales/it.js'
import tr from './locales/tr.js'

const messages = {
  'zh-cn': zhCn,
  'zh-tw': zhTw,
  'en': en,
  'fr': fr,
  'pt': pt,
  'es': es,
  'pl': pl,
  'de': de,
  'it': it,
  'tr': tr
}

const supportedLocales = Object.keys(messages)

const normalizeLocale = (locale) => {
  if (!locale) return 'en'
  if (supportedLocales.includes(locale)) return locale
  if (locale === 'zh-tw' || locale === 'zh-hk' || locale === 'zh-hant') return 'zh-tw'
  if (locale === 'zh' || locale.startsWith('zh')) return 'zh-cn'
  return 'en'
}

// 站点默认语言版本：升级后清掉旧缓存，确保新访客/旧缓存走最新默认英语
const LANG_VERSION = 'urmat-en-1'
try {
  if (localStorage.getItem('app_lang_version') !== LANG_VERSION) {
    localStorage.removeItem('selected_language')
    localStorage.setItem('tenant_default_language', 'en')
    localStorage.setItem('app_lang_version', LANG_VERSION)
  }
} catch (_e) { /* ignore */ }

// 获取租户默认语言（从 localStorage 读取，API 加载后会写入）
const getTenantDefaultLanguage = () => {
  return normalizeLocale(localStorage.getItem('tenant_default_language') || 'en')
}

// 获取用户选择的语言，未选择则使用租户默认语言
const getDefaultLocale = () => {
  const savedLanguage = localStorage.getItem('selected_language')
  return normalizeLocale(savedLanguage || getTenantDefaultLanguage())
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages,
  missingWarn: false,
  fallbackWarn: false
})

export default i18n
export { normalizeLocale, supportedLocales }
